import type { ReactNode } from 'react'
import { Icon, type IconName } from '../components/ui/Icon'

type DecisionBriefSectionProps = {
  icon: IconName
  eyebrow?: string
  title: ReactNode
  description?: string
  tone?: 'default' | 'attention' | 'positive'
  children?: ReactNode
}

export function DecisionBriefSection({
  icon,
  eyebrow,
  title,
  description,
  tone = 'default',
  children,
}: DecisionBriefSectionProps) {
  return (
    <section className={'panel decision-brief-section decision-brief-section-' + tone}>
      <header className="decision-brief-section-heading">
        <span className="decision-brief-icon"><Icon name={icon} size={20} /></span>
        <div>
          {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
          <h2>{title}</h2>
          {description ? <p className="decision-brief-description">{description}</p> : null}
        </div>
      </header>
      {children ? <div className="decision-brief-section-body">{children}</div> : null}
    </section>
  )
}

export type DecisionBriefFact = {
  label: string
  value: ReactNode
  detail?: ReactNode
}

export function DecisionBriefFacts({ facts }: { facts: DecisionBriefFact[] }) {
  return (
    <dl className="decision-brief-facts">
      {facts.map((fact) => (
        <div key={fact.label}>
          <dt>{fact.label}</dt>
          <dd>{fact.value}</dd>
          {fact.detail ? <small>{fact.detail}</small> : null}
        </div>
      ))}
    </dl>
  )
}

export function DecisionBriefChecklist({ items }: { items: { label: ReactNode; status: 'ready' | 'attention' | 'neutral' }[] }) {
  return (
    <ul className="decision-brief-checklist">
      {items.map((item, index) => (
        <li className={item.status} key={index}>
          <Icon name={item.status === 'ready' ? 'check' : item.status === 'attention' ? 'alert' : 'info'} size={17} />
          <span>{item.label}</span>
        </li>
      ))}
    </ul>
  )
}

